/* src/app/main/pages/home-page/component/latest-news/unconventional-charter-solution/unconventional-charter-solution.component.css */
.case-study {
  box-shadow: 0px 0px 3px #ccc;
}
.case-study p {
  font-size: 15px;
  color: #000;
}
/*# sourceMappingURL=unconventional-charter-solution.component.css.map */
